<template>
  <div>
    <button type="button" class="icon-btn" title="Edit category" @click="showmodal">
      <feather type="edit-2" size="16"></feather>
    </button>
    <b-modal size="xl" :id="'modal-CategoryEdit' + id" title="Category Edit" hide-footer @show="OnShowModal" @hide="clear"
      no-close-on-esc no-close-on-backdrop>
      <div class="container-fluid">
        <b-modal ref="alert-edit-category" title="Admin" @ok="close()" ok-only>
          <p class="my-4">{{ message }}</p>
        </b-modal>
        <div class="row product-adding">
          <div class="col-xl-12">
            <b-card no-body>
              <b-card-text>
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationcategoryname" class="col-form-label pt-0">Category name <span>*</span></label>
                    <ValidationProvider name="categoryen" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationcategoryname" type="text" v-model="vcategory"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <label>Category description</label>
                  <vue-editor v-model="vdescription"></vue-editor>
                  <br />
                  <div class="form-group">
                    <label for="validationoffer" class="col-form-label pt-0">Offer</label>
                    <input class="form-control" id="validationoffer" type="text" v-model="voffer" required="" />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label pt-0">Banner Upload <span>*</span></label>
                    <vue-dropzone id="editCat" :options="EditCatOptions" class="dropzone digits" ref="EditCat"
                      :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess"
                      v-on:vdropzone-removed-file="fileRemoved" @vdropzone-complete="uploadComplete"
                      @vdropzone-sending="sending" @vdropzone-error="uploadError">
                    </vue-dropzone>
                  </div>
                  <div class="form-group">
                    <label for="validationmetatitle" class="col-form-label pt-0">Meta title</label>
                    <input class="form-control" id="validationmetatitle" type="text" v-model="vmetatitle" required="" />
                  </div>
                  <div class="form-group">
                    <label for="validationmetadescription" class="col-form-label pt-0">Meta description</label>
                    <input class="form-control" id="validationmetadescription" type="text" v-model="vmetadescription"
                      required="" />
                  </div>
                  <div class="form-group">
                    <label for="validationmetadescription" class="col-form-label pt-0">Meta keywords</label>
                    <input class="form-control" id="validationmetadescription" type="text" v-model="vmetakeywords"
                      required="" />
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
        <div class="col-xl-12 pb-3">
          <div class="form-group mb-0">
            <div class="product-buttons text-right">
              <button type="button" class="btn btn-light mr-2" @click="back">
                Cancel
              </button>
              <button type="button" class="btn btn-primary" @click="save">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </b-modal>
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders, reportUploadError } from './../../../utils/imageUpload';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { uuid } from "vue-uuid";
export default {
  props: ["id", "category", "description", "offer", "image", "metaTitle", "metaDescription", "metaKeywords", "host"],
  data() {
    return {
      vid: null,
      vcategory: null,
      vdescription: null,
      voffer: null,
      vimage: null,
      vmetatitle: null,
      vmetadescription: null,
      vmetakeywords: null,
      message: "",
      error: 0,
      editor: ClassicEditor,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      selectMode: "single",
      banner: null,
      EditCatOptions: {
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 250,
        thumbnailHeight: 250,
        maxFiles: 1,
        params: [],
        maxfilesexceeded: function (file) {
          this.removeAllFiles();
          this.addFile(file);
        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.removeAllFiles();
          let image = this.options.params[0].image;
          let f = {
            size: '12300',
            name: this.options.params[0].id,
            dataURL: image,
          };
          this.files.push(f);
          this.emit("addedfile", f);
          this.emit("thumbnail", f, f.dataURL);
          this.emit("complete", f);
          this.on("removedfile", function (file) {
            return null;
          });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
      },
    };
  },
  methods: {
    save() {
      if (this.vcategory == "") {
        this.message = "Please complete all required fields!";
        this.error = 1;
        this.$refs['alert-edit-category'].show()
        return false;
      } else {
        this.error = 0;
      }
      if (this.error == 1) {
        this.message = "Error writing document!";
        this.error = 1;
        this.$refs['alert-edit-category'].show()
        return false;
      }
      let form = {
        category: this.vcategory.toUpperCase(),
        description: this.vdescription,
        image: this.vimage,
        offer: this.voffer,
        metaTitle: this.vmetatitle,
        metaDescription: this.vmetadescription,
        metaKeywords: this.vmetakeywords
      }
      this.$emit('ok', form);
      this.$bvModal.hide('modal-CategoryEdit' + this.id);
    },
    close() {
      if (this.error == 0) this.$bvModal.hide('modal-CategoryEdit' + this.id);
    },
    back() {
      this.$bvModal.hide('modal-CategoryEdit' + this.id);
    },
    clear() {
      this.vcategory = "";
      this.vdescription = "";
      this.vimage = "";
      this.voffer = "";
      this.vmetatitle = "";
      this.vmetadescription = "";
      this.vmetakeywords = "";
    },
    showmodal() {
      this.$bvModal.show('modal-CategoryEdit' + this.id);
    },
    OnShowModal() {
      this.vcategory = this.category;
      this.vdescription = this.description;
      this.vimage = this.image;
      this.voffer = this.offer;
      this.vmetatitle = this.metaTitle;
      this.vmetadescription = this.metaDescription;
      this.vmetakeywords = this.metaKeywords;
      this.EditCatOptions.params.push({
        "id": this.id,
        "image": this.image
      })
    },
    uploadComplete(file, response) {
      // L'API renvoie directement { url: '/uploads/...' } : l'image est
      // déjà stockée sur le serveur, plus besoin de renvoyer l'aperçu.
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.vimage = data.url;
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },
    fileRemoved() {

    },
    uploadSuccess() {

    },
    uploadError(file, message) {
      reportUploadError(this, message);
    },
    sending(file, xhr, formData) {
      // Juste avant l'envoi : indique à l'API le dossier de stockage
      // (l'option dropzone « params » est déjà utilisée pour l'affichage
      // de l'image existante, on passe par cet événement à la place).
      formData.append('folder', 'sites/' + this.host + '/categories');
    }
  }
};
</script>
<style lang="scss" scoped></style>